<template>
  <div>
    <new-main-header v-if="hasNewLeftNavEnabled">
      Customer Devices
    </new-main-header>
    <main-header v-else>
      <span slot="arrow-back">
        <el-tooltip
            class="item"
            effect="dark"
            content="Back to Start Page"
            placement="bottom-start">
          <router-link :to="{ name: 'HomePage' }"><i class="el-icon-back" /> </router-link>
        </el-tooltip>
      </span>
      <span slot="page-title">Customer Devices</span>
    </main-header>
    <main-content>
      <el-menu
          v-if="false"
          slot="horizontal-menu"
          class="ring-menu--horizontal"
          default-active="1"
          mode="horizontal">
        <el-menu-item
            v-scroll-to="{
              el: '#devices__ring-devices-table',
              container: '#main-content',
              duration: 500,
              easing: 'linear'}"
            index="1">
          <span>Ring Devices</span>
        </el-menu-item>
        <el-menu-item
            v-scroll-to="{
              el: '#devices__third-party-devices-table',
              container: '#main-content',
              duration: 500,
              easing: 'linear'}"
            index="2">
          <span>Third Party Devices</span>
        </el-menu-item>
        <el-menu-item
            v-scroll-to="{
              el: '#devices__client-devices-table',
              container: '#main-content',
              duration: 500,
              easing: 'linear'}"
            index="3">
          <span>Client Devices</span>
        </el-menu-item>
      </el-menu>

      <div slot="main-content">
        <devices-table
            id="devices__ring-devices-table"
            :customer-id="customer.id" />

        <third-party-devices-table
            id="devices__third-party-devices-table" />

        <!-- CUSTOMER ACCESSORIES-->
        <accessories :customer="customer" />

        <!--CLIENT DEVICES-->

        <client-devices
            id="devices__client-devices-table"
            style="min-height: 400px"
            class="span-12 span-12-t"
            :customer="customer" />
      </div>
    </main-content>
  </div>
</template>

<script>
import MainContent from "@/containers/Core/MainContent";
import MainHeader from "@/containers/Core/Header/MainHeader";
import DevicesTable from "@/containers/Customer/Devices/DevicesTable";
import ThirdPartyDevicesTable from "@/containers/Customer/Devices/ThirdPartyDevicesTable";
import Accessories from "@/containers/Customer/Devices/Accessories";
import ClientDevices from "@/containers/Customer/Profile/ClientDevices";
import NewMainHeader from "@/NewUI/containers/core/header/MainHeader";

import permission from "@/mixins/permission";
import { createNamespacedHelpers } from "vuex";

const { mapGetters: accountGetters } = createNamespacedHelpers("db/account");

export default {
  name: "DevicesPage",
  components: {
    MainContent,
    MainHeader,
    ClientDevices,
    DevicesTable,
    ThirdPartyDevicesTable,
    Accessories,
    NewMainHeader,
  },
  mixins: [permission],
  computed: {
    ...accountGetters(["customer", "email"]),
    hasNewLeftNavEnabled() {
      return this.hasPermission("NewUI", "leftNav");
    },
  },
  mounted() {
    setTimeout(() => this.scrollToHash("#"), 1000);
  },
  methods: {
    scrollToHash() {
      let section = this.$route.hash;
      if (section) {
        this.$nextTick(() => {
          this.$scrollTo(section, {
            duration: 500,
            container: "#main-content",
          });
        });
      }
    },
  },
};
</script>

<style lang="scss"></style>
